import { render, staticRenderFns } from "./ProfileEditBtn.vue?vue&type=template&id=403376ae&scoped=true&"
import script from "./ProfileEditBtn.vue?vue&type=script&lang=js&"
export * from "./ProfileEditBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403376ae",
  null
  
)

export default component.exports